import React from 'react';
import { ArrowRightIcon, XIcon } from 'lucide-react';
import { PROBLEM_POINTS } from '../data/site';
export function ProblemSection() {
  return <section className="bg-white py-10 sm:py-16" data-id="element-233" data-mp="2lu4nrhl7rk6p">
      <div className="mx-auto grid max-w-content grid-cols-1 gap-6 px-4 sm:px-6 lg:grid-cols-[minmax(0,0.95fr)_minmax(0,1.05fr)] lg:gap-16" data-id="element-234" data-mp="30hpnd1ivr19v">
        <div data-id="element-235" data-mp="2vp6cwdfhom9a">
          <h2 className="font-display text-[1.75rem] font-bold leading-tight text-navy-900 sm:text-4xl" data-id="element-236" data-mp="2voehp3pt0qjj">
            Comprar material para losa no debería sentirse como entrar a un laberinto
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-steel-600 sm:text-base" data-id="element-237" data-mp="35in5je3w3vbd">
            Cotizaciones incompletas, fletes sorpresa y proveedores que no contestan cuestan días de obra. En OA
            LOSAS te damos el camino corto: precio visible, entrega clara y respuesta rápida.
          </p>
          <div className="mt-5 flex items-start gap-3 rounded-lg border-l-4 border-signal-600 bg-steel-50 px-4 py-3.5" data-id="element-238" data-mp="1p3vmvswjq2f9">
            <ArrowRightIcon className="mt-0.5 h-5 w-5 shrink-0 text-signal-600" aria-hidden="true" data-id="element-239" data-mp="jdn6o81bl671" />
            <p className="text-sm font-medium text-navy-800 sm:text-[15px]" data-id="element-240" data-mp="obonemb9wtfc">
              Medida, cantidad, ciudad y fecha. Con eso cerramos tu pedido por WhatsApp.
            </p>
          </div>
        </div>

        <ul className="grid gap-2" data-id="element-241" data-mp="x4rwyjissm4p">
          {PROBLEM_POINTS.map(point => <li key={point} className="flex items-center gap-3 rounded-md bg-steel-50 px-4 py-3 text-sm text-navy-800 sm:text-[15px]" data-id="element-242" data-mp="123v1m2uv8qc5">
              <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-white text-steel-600 ring-1 ring-steel-200" data-id="element-243" data-mp="174iuku2nnh90">
                <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-244" data-mp="1g2co5x91bwsh" />
              </span>
              {point}
            </li>)}
        </ul>
      </div>
    </section>;
}